import { INITIAL_SCORE } from "../constants";
import { Answer, Content, Score } from "../types";

export const markAnswer = (content: Content, answer: Answer): Score => {
  if (!answer) {
    return INITIAL_SCORE;
  }

  const {
    select: { testedWordIndex }
  } = content;
  const {
    select: { index: selectedIndex },
    multipleChoice: multipleChoiceAnswer
  } = answer;

  const selectCorrect = selectedIndex === testedWordIndex;

  const multipleChoiceCorrect =
    multipleChoiceAnswer.index === content.multipleChoice.correctAnswerIndex;

  return {
    score: getOverallScore(selectCorrect, multipleChoiceCorrect),
    select: {
      score: selectCorrect ? 1 : 0
    },
    multipleChoice: {
      score: multipleChoiceCorrect ? 1 : 0
    }
  };
};

const FIRST_STAGE_SCORE_WEIGHT = 0.5;
const MULTIPLE_CHOICE_SCORE_WEIGHT = 0.5;

const getOverallScore = (
  selectCorrect: boolean,
  multipleChoiceCorrect?: boolean
): number => {
  let score = 0;

  if (selectCorrect) {
    score += FIRST_STAGE_SCORE_WEIGHT;
  }

  if (multipleChoiceCorrect) {
    score += MULTIPLE_CHOICE_SCORE_WEIGHT;
  }

  return score;
};
